// src/utils/listReturn.js
//
// Posición de una lista (scroll, elemento abierto y extras como tarjetas
// expandidas) para dejarla igual al volver desde una ficha. Se guarda en
// sessionStorage junto con la query string de la lista: solo se restaura si la
// URL al volver es la misma. Se consume una sola vez.
const KEY = 'csr:claims-return';

export const rememberListPosition = (search, id, extra = {}) => {
  try { sessionStorage.setItem(KEY, JSON.stringify({ search, y: window.scrollY, id, ...extra })); } catch { /* sin storage: se vuelve arriba */ }
};

// `accept(saved)` decide si esta lista es la dueña de la posición (p. ej. por pestaña).
export const peekListPosition = search => {
  try {
    const saved = JSON.parse(sessionStorage.getItem(KEY));
    return saved && saved.search === search ? saved : null;
  } catch { return null; }
};

export const clearListPosition = () => {
  try { sessionStorage.removeItem(KEY); } catch { /* ignorar */ }
};

export const scrollToListPosition = saved => {
  window.scrollTo(0, saved.y || 0);
  if (saved.id) document.querySelector(`[data-claim-id="${CSS.escape(String(saved.id))}"]`)?.focus?.({ preventScroll: true });
};
